(() => {
  const redirectStorageKey = 'najju-notify-destination';

  /*
   * If Shopify ever ignores the hidden target and completes the customer form
   * as a full-page navigation, resume the intended Shop journey immediately.
   */
  try {
    const storedDestination = window.sessionStorage.getItem(redirectStorageKey);
    if (storedDestination) {
      window.sessionStorage.removeItem(redirectStorageKey);
      window.location.replace(storedDestination);
      return;
    }
  } catch (_) {
    // Storage can be unavailable in strict privacy modes; the iframe path still works.
  }

  const dialog = document.querySelector('[data-najju-notify-dialog]');
  const target = document.querySelector('[data-najju-notify-target]');
  if (!(dialog instanceof HTMLDialogElement) || !(target instanceof HTMLIFrameElement)) return;

  const form = dialog.querySelector('#NajjuNotifyForm');
  const email = dialog.querySelector('#NajjuNotifyEmail');
  const tags = dialog.querySelector('[data-najju-notify-tags]');
  const submit = dialog.querySelector('[data-najju-notify-submit]');
  const error = dialog.querySelector('[data-najju-notify-error]');
  const close = dialog.querySelector('[data-najju-notify-close]');
  let destination = '';
  let awaitingShopify = false;
  let timeoutId = 0;

  if (!(form instanceof HTMLFormElement) || !(email instanceof HTMLInputElement)) return;

  const resetState = () => {
    if (error instanceof HTMLElement) error.hidden = true;
    if (submit instanceof HTMLButtonElement) {
      submit.disabled = false;
      submit.textContent = submit.dataset.defaultLabel || 'Continue';
    }
  };

  const clearStoredDestination = () => {
    try {
      window.sessionStorage.removeItem(redirectStorageKey);
    } catch (_) {
      // No action required.
    }
  };

  const continueToShop = () => {
    if (!destination) return;
    window.clearTimeout(timeoutId);
    awaitingShopify = false;
    clearStoredDestination();
    window.location.replace(destination);
  };

  const closeDialog = () => {
    if (dialog.open) dialog.close();
  };

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element
      ? event.target.closest('a.najju-notify-link')
      : null;

    if (!(link instanceof HTMLAnchorElement)) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    destination = link.href;
    resetState();

    try {
      const productId = new URL(destination, window.location.origin)
        .pathname
        .match(/\/products\/(\d+)/)?.[1];
      if (tags instanceof HTMLInputElement) {
        tags.value = [
          'najju-notify',
          'back-in-stock',
          productId ? `back-in-stock-${productId}` : ''
        ].filter(Boolean).join(', ');
      }
    } catch (_) {
      if (tags instanceof HTMLInputElement) {
        tags.value = 'najju-notify, back-in-stock';
      }
    }

    dialog.showModal();
    window.requestAnimationFrame(() => email.focus());
  });

  close?.addEventListener('click', closeDialog);

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });

  target.addEventListener('load', () => {
    if (!awaitingShopify) return;
    continueToShop();
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!destination || !form.reportValidity() || awaitingShopify) return;

    resetState();
    awaitingShopify = true;

    if (submit instanceof HTMLButtonElement) {
      submit.disabled = true;
      submit.textContent = submit.dataset.savingLabel || 'Saving…';
    }

    try {
      window.sessionStorage.setItem(redirectStorageKey, destination);
    } catch (_) {
      // The hidden iframe remains the primary redirect mechanism.
    }

    form.setAttribute('target', target.getAttribute('name') || 'NajjuNotifyTarget');

    /*
     * Use Shopify's native customer-form submission. Fetch/AJAX can report a
     * false error after Shopify has already saved a pending double-opt-in record.
     */
    HTMLFormElement.prototype.submit.call(form);

    timeoutId = window.setTimeout(() => {
      if (!awaitingShopify) return;
      awaitingShopify = false;
      clearStoredDestination();

      if (error instanceof HTMLElement) error.hidden = false;
      if (submit instanceof HTMLButtonElement) {
        submit.disabled = false;
        submit.textContent = submit.dataset.defaultLabel || 'Continue';
      }
      email.focus();
    }, 15000);
  });
})();
